'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';

export const leagueManageSettingRoutes = [
  {
    path: 'settings',
    name: 'league.manage.setting.edit',
    props: true,
    component: () => import('../views/ManageSettingView.vue'),
  },
];
